import { createContext, useState } from "react";

const FormContext = createContext({});

export const FormProvider = ({ children }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [filterEntry, setFilterEntry] = useState(false);
  const [isLodaing, setIsLoading] = useState(false)

  return (
    <FormContext.Provider value={{ isFormOpen, setIsFormOpen, filterEntry, setFilterEntry, isLodaing, setIsLoading }}>
      {children}
    </FormContext.Provider>
  );
};

export default FormContext;
